export enum CoverageType {
    Covered = 1,
    NotCovered = 2,
    Approval = 3
}
